import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, TermSheetRevision } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useLenderTermSheetRevisionsQuery(
	dataRoomGuid?: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<TermSheetRevision[], unknown, TermSheetRevision[], any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.TermSheets.Revisions(dataRoomGuid),
		() =>
			AxiosUtils.getResponseData<TermSheetRevision[]>(
				api.get(CerebroApiEndpoints.TermSheets.Revisions(dataRoomGuid))
			),
		options
	);
}
